// Default port for servers.
export const server = 3000

// Port for web projects being served with HMR.
//
// In this mode, Parcel serves the project with HMR on the HMR port,
// but we still need to run the backend on the server port.
// This is why the HMR and server ports must be different.
export const hmr = 4000
